import { render } from "./HelpVideoDetail.vue?vue&type=template&id=2bd34ce5"
import script from "./HelpVideoDetail.vue?vue&type=script&lang=js"
export * from "./HelpVideoDetail.vue?vue&type=script&lang=js"
script.render = render

export default script

/* vue-cli-plugin-import-components */
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import HelpVideoEditItem from "@/components/HelpVideoEditItem.vue";
script.components = Object.assign({}, { Breadcrumbs, HelpVideoEditItem }, script.components);